import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { Button } from '../components/common/Button';
import { Trash2, Plus, Minus, ShoppingBag, ArrowLeft } from 'lucide-react';
import styles from './CartPage.module.css';

export function CartPage() {
  const navigate = useNavigate();
  const { items, removeFromCart, updateQuantity, getCartTotal, getCartCount } = useCart();

  if (items.length === 0) {
    return (
      <div className={styles.cartPage}>
        <div className={styles.container}>
          <div className={styles.emptyCart}>
            <ShoppingBag size={64} className={styles.emptyIcon} />
            <h2>Your cart is empty</h2>
            <p>Looks like you haven't added any paint kits yet.</p>
            <Button variant="primary" onClick={() => navigate('/products/kits')}>
              Browse Paint Kits
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.cartPage}>
      <div className={styles.container}>
        <button onClick={() => navigate('/products/kits')} className={styles.backButton}>
          <ArrowLeft size={20} />
          Continue Shopping
        </button>

        <h1 className={styles.title}>Shopping Cart</h1>
        <p className={styles.subtitle}>{getCartCount()} item{getCartCount() !== 1 ? 's' : ''} in your cart</p>

        <div className={styles.cartContent}>
          {/* Cart Items */}
          <div className={styles.cartItems}>
            {items.map((item) => (
              <div key={item.id} className={styles.cartItem}>
                <div className={styles.itemImage}>
                  <img src={item.imageUrl} alt={item.name} />
                </div>
                <div className={styles.itemDetails}>
                  <h3 className={styles.itemName}>{item.name}</h3>
                  {item.size && (
                    <div className={styles.itemMeta}>
                      <span className={styles.itemSize}>{item.size}</span>
                    </div>
                  )}
                  <p className={styles.itemPrice}>EGP {item.price}</p>
                </div>
                <div className={styles.itemActions}>
                  <div className={styles.quantityControl}>
                    <button
                      className={styles.quantityBtn}
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    >
                      <Minus size={16} />
                    </button>
                    <span className={styles.quantity}>{item.quantity}</span>
                    <button
                      className={styles.quantityBtn}
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    >
                      <Plus size={16} />
                    </button>
                  </div>
                  <p className={styles.itemTotal}>EGP {item.price * item.quantity}</p>
                  <button
                    className={styles.removeBtn}
                    onClick={() => removeFromCart(item.id)}
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Order Summary */}
          <div className={styles.orderSummary}>
            <h2>Order Summary</h2>
            <div className={styles.summaryRow}>
              <span>Subtotal</span>
              <span>EGP {getCartTotal()}</span>
            </div>
            <div className={styles.summaryRow}>
              <span>Shipping</span>
              <span>Calculated at checkout</span>
            </div>
            <div className={styles.summaryTotal}>
              <span>Total</span>
              <span>EGP {getCartTotal()}</span>
            </div>
            <Button
              variant="primary"
              onClick={() => navigate('/checkout')}
              className={styles.checkoutBtn}
            >
              Proceed to Checkout
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
